// extDataGroups/reducer.js
import constants from "../../commonUtils/constants";
import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  filters: { keyword: "" },
  ExtDataGroupsList: constants.extraction.listInitialState,
  extDataGroup: null,
  openModal: false,
  errors: {},
  errorMessage: ""
};

const ExtDataGroups = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
      
    case actionTypes.SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
      
    case actionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    
    case actionTypes.SET_OPEN_MODAL:
      return {
        ...state,
        openModal: action.payload,
        loading: action.payload ? state.loading : false,
        extDataGroup: action.payload ? state.extDataGroup : null,
      };
    
    case actionTypes.SET_EXT_DATA_GROUP:
      return {
        ...state,
        extDataGroup: action.payload,
      };
      
    case actionTypes.GET_EXT_DATA_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        ExtDataGroupsList: action.payload,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.GET_EXT_DATA_GROUPS_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to fetch data groups"
      };

    case actionTypes.GET_EXT_DATA_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        extDataGroup: action.payload,
        openModal: true,
        errors: {},
        errorMessage: "",
      };
    
    case actionTypes.GET_EXT_DATA_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        openModal: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to fetch data groups"
      };
      
    case actionTypes.CREATE_EXT_DATA_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        openModal: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.CREATE_EXT_DATA_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors || {},
        errorMessage: action.payload.message || "Failed to create data group"
      };
      
    case actionTypes.UPDATE_EXT_DATA_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        openModal: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.UPDATE_EXT_DATA_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors || {},
        errorMessage: action.payload.message || "Failed to update data group"
      };
    
    case actionTypes.UPDATE_EXT_DATA_GROUPS_ORDER_SUCCESS:
      return {
        ...state,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.UPDATE_EXT_DATA_GROUPS_ORDER_FAILURE:
      return {
        ...state,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to update order"
      };
    
    case actionTypes.DELETE_EXT_DATA_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.DELETE_EXT_DATA_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to delete data group"
      };
      
    default:
      return state;
  }
};

export default ExtDataGroups;